<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.username"
          name="username"
          :label="`${$t('USERS.USERNAME')} *`"
          :readonly="readonly"
          :rules="getRulesByName('username')"
          :error-messages="errors.username"
          @input="updateValue('username', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <text-field-password-generate
          v-model="form.password"
          name="password"
          :label="`${$t('USERS.PASSWORD')} *`"
          :counter="8"
          :readonly="readonly"
          :rules="getRulesByName('password')"
          :error-messages="errors.password"
          @input="updateValue('password', $event)"
        ></text-field-password-generate>
      </v-col>
      <v-col class="d-flex justify-space-between align-center" cols="12" md="4">
        <v-row>
          <div>
            <v-subheader v-text="`${$t('ITEM.CATEGORY')}:`"></v-subheader>
          </div>

          <div class="d-flex justify-space-between align-center">
            <v-chip
              v-for="(item, index) in form.roles"
              :key="index"
              :class="{ 'mr-2': index !== form.roles.length - 1 }"
              color="primary"
              small
            >
              {{ item.slug }}
            </v-chip>
          </div>
          <v-spacer />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import TextFieldPasswordGenerate from '@/modules/_global/_components/TextFieldPasswordGenerate';
import { notEmpty, maxLength } from '@/modules/_global/variables/rules';

export default {
  name: 'EmployeeAccessMyeReporterForm',

  components: {
    TextFieldPasswordGenerate
  },

  mixins: [formEditable],

  data() {
    return {
      valid: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [notEmpty],
        password: [maxLength(8)]
      }
    };
  },

  methods: {
    getRulesByName(name) {
      if (this.readonly) {
        return [];
      }

      return this.rules[name];
    }
  }
};
</script>
